var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.summary)?_c('div',{class:_vm.statusStyling},[_c('v-icon',{attrs:{"color":_vm.statusIconColor}},[_vm._v("\n    "+_vm._s(_vm.statusIcon)+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.summary)+". "+_vm._s(_vm.summaryError)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }